import request from '../config/axiosConfig';

const DSP_API_SECRET = process.env.REACT_APP_DSP_API_SECRET;

const withSecretHeader = (config = {}) => {
  const headers = {
    ...(config.headers || {}),
    apisecret: DSP_API_SECRET,
  };

  return { ...config, headers };
};

export const fetchCronJobs = async () => {
  const response = await request.post(
    '/cron-log/jobs',
    {},
    withSecretHeader()
  );

  return response?.data;
};

export const fetchCronJobHistory = async ({ jobName, limit = 50 }) => {
  const response = await request.post(
    '/cron-log/history',
    { jobName, limit },
    withSecretHeader()
  );

  return response?.data;
};

export default {
  fetchCronJobs,
  fetchCronJobHistory,
};

